module.exports = __webpack_public_path__ + "img/potter-logo.0dc7279f.png";